import React, {useState} from 'react';
import CustomText from './CustomText.styled';
import Div from './Div.styled';
import styled from 'styled-components';
import {Spinner} from '@volkswagen-onehub/components-core';

export type OptionItem = {
  id: string;
  label: string;
  value: string;
};

type DropdownInputProps = {
  options: OptionItem[];
  handleOptionChange: (option: OptionItem) => void;
  dropdownMaxHeight: number;
  message?: string;
  loading?: boolean;
};

const DropdownItem = styled(CustomText)<{isHovered: boolean}>`
  color: ${(props) => (props.isHovered ? '#001E50' : 'white')};
  padding: 12px 16px;
  background-color: ${(props) => (props.isHovered ? 'white' : 'transparent')};
  cursor: ${(props) => (props.isHovered ? 'pointer' : 'default')};
  font-size: 16px;
`;

const DropdownInput: React.FC<DropdownInputProps> = ({
  options,
  handleOptionChange,
  dropdownMaxHeight,
  message,
  loading,
}) => {
  const [hoveredItem, setHoveredItem] = useState<number | null>(null);

  return (
    <Div
      customStyles={{
        position: 'absolute',
        height: `${dropdownMaxHeight || 42}px`,
        top: 65,
        background: '#0161cb',
        zIndex: 1,
        overflowY: 'scroll',
        boxShadow: '0 0 10px rgba(0, 0, 0, 0.2)',
      }}
      width="100%"
    >
      {loading ? (
        <Div
          customStyles={{
            padding: 10,
            color: '#000',
            height: 42,
            textAlign: 'center',
          }}
        >
          <Spinner />
        </Div>
      ) : options?.length > 0 ? (
        options.map((option, i) => {
          const isHovered = i === hoveredItem;

          return (
            <DropdownItem
              key={i}
              isHovered={isHovered}
              onClick={() => handleOptionChange(option)}
              onMouseEnter={() => setHoveredItem(i)}
              onMouseLeave={() => setHoveredItem(null)}
            >
              {option.label}
            </DropdownItem>
          );
        })
      ) : (
        <CustomText
          customStyles={{
            padding: 10,
            color: '#fff',
            height: 42,
          }}
        >
          {message}
        </CustomText>
      )}
    </Div>
  );
};

export default DropdownInput;
